var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"table-status-fns",style:(("color: " + (_vm.getStatus.color)))},[_vm._v(" "+_vm._s(_vm.getStatus.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }